import type React from "react"
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table"

interface DataTableProps {
  columnNames: string[]
  rows: Record<string, any>[]
}

export const DataTable: React.FC<DataTableProps> = ({ columnNames, rows }) => {
  return (
    <div className="w-full max-w-[985px] overflow-x-auto max-h-[260px] border-black/20 border rounded-md">
      <div className="min-w-full inline-block align-middle">
        <div className="overflow-hidden">
          <Table>
            <TableHeader>
              <TableRow>
                {columnNames.map((columnName, index) => (
                  <TableHead key={index} className="whitespace-nowrap">
                    {columnName}
                  </TableHead>
                ))}
              </TableRow>
            </TableHeader>
            <TableBody>
              {rows.map((row, rowIndex) => (
                <TableRow key={rowIndex}>
                  {columnNames.map((columnName, colIndex) => (
                    <TableCell key={`${rowIndex}-${colIndex}`} className="whitespace-nowrap">
                      {row[columnName] !== undefined ? row[columnName] : "-"}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  )
}

